import { render, staticRenderFns } from "./AppointmentDataCardSkeleton.vue?vue&type=template&id=08fc7d66&scoped=true&"
import script from "./AppointmentDataCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./AppointmentDataCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDataCardSkeleton.vue?vue&type=style&index=0&id=08fc7d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc7d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fc7d66')) {
      api.createRecord('08fc7d66', component.options)
    } else {
      api.reload('08fc7d66', component.options)
    }
    module.hot.accept("./AppointmentDataCardSkeleton.vue?vue&type=template&id=08fc7d66&scoped=true&", function () {
      api.rerender('08fc7d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentDataCard/components/AppointmentDataCardSkeleton.vue"
export default component.exports